<template>
  <div class="panel">
    <div class="panel-head">
      <div class="panel-title">{{ $t('chi82') }}</div>
      <span class="unit">{{ $t('chi150') }}</span>
    </div>
    <div class="panel-body">
      <div class="donut-wrap">
        <div class="donut" :style="{ background: donutStyle }">
          <div class="donut-text">
            <b>{{ Math.round(rate * 100) }}%</b>
            <span>{{ $t('chi83') }}</span>
          </div>
        </div>
        <div class="legend">
          <div>
            <span><i class="dot" style="background: #36c78c"></i>{{ $t('chi84') }}</span>
            <b>{{ fmt(onlineHours, 0) }} {{ $t('chi106') }}</b>
          </div>
          <div>
            <span><i class="dot" style="background: #e9f1f5"></i>{{ $t('chi85') }}</span>
            <b>{{ fmt(offlineHours, 0) }} {{ $t('chi106') }}</b>
          </div>
          <div>
            <span><i class="dot" style="background: #ffb44c"></i>{{ $t('chi86') }}</span>
            <b>{{ fmt(summary.power_on_count, 0) }}</b>
          </div>
          <div>
            <span><i class="dot" style="background: #3aa8ff"></i>{{ $t('chi87') }}</span>
            <b>{{ fmt(mediaPlays, 0) }}</b>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { fmt, secToHours } from "./statUtils.js";

export default {
  name: "AvailabilityDonut",
  props: {
    // getDeviceBootLog 返回的 summary
    summary: { type: Object, default: () => ({}) },
    // 媒体播放总次数（getHistoryMediaStatistics 求和）
    mediaPlays: { type: Number, default: 0 },
  },
  computed: {
    onlineHours() {
      return secToHours(this.summary.total_runtime || 0);
    },
    // 可用率推导：运行时长 / (设备数 × 天数 × 24h)，接口无在线/离线时长拆分
    maxHours() {
      const { device_count = 0, days = 0 } = this.summary;
      return device_count * days * 24;
    },
    rate() {
      if (this.maxHours <= 0) return 0;
      return Math.min(1, this.onlineHours / this.maxHours);
    },
    offlineHours() {
      return Math.max(0, this.maxHours - this.onlineHours);
    },
    donutStyle() {
      const pct = this.rate * 100;
      return `conic-gradient(#36c78c 0 ${pct}%, #e9f1f5 ${pct}% 100%)`;
    },
  },
  methods: {
    fmt,
  },
};
</script>

<style lang="scss" scoped>
.panel {
  background: #fff;
  border: 1px solid #dcecf4;
  border-radius: 15px;
  box-shadow: 0 8px 28px rgba(31, 142, 190, 0.08);
  overflow: hidden;
}
.panel-head {
  padding: 16px 18px;
  border-bottom: 1px solid #dcecf4;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
}
.panel-title {
  font-weight: 800;
  font-size: 16px;
  color: #314356;
}
.unit {
  color: #8ca0af;
  font-size: 12px;
}
.panel-body {
  padding: 18px;
}
.donut-wrap {
  display: flex;
  align-items: center;
  gap: 28px;
  min-height: 250px;
  justify-content: center;
  flex-wrap: wrap;
}
.donut {
  width: 170px;
  height: 170px;
  border-radius: 50%;
  display: grid;
  place-items: center;
  position: relative;

  &::after {
    content: "";
    width: 112px;
    height: 112px;
    border-radius: 50%;
    background: #fff;
    position: absolute;
  }
}
.donut-text {
  position: relative;
  z-index: 1;
  text-align: center;

  b {
    font-size: 28px;
    color: #243a4b;
  }

  span {
    display: block;
    color: #7f93a6;
    font-size: 12px;
  }
}
.legend {
  display: grid;
  gap: 10px;

  > div {
    display: flex;
    justify-content: space-between;
    gap: 20px;
    font-size: 14px;
    align-items: center;
    color: #314356;
  }
}
.dot {
  width: 9px;
  height: 9px;
  border-radius: 50%;
  display: inline-block;
  margin-right: 8px;
}
</style>
